import { NgModule } from '@angular/core';
import { PreventSpaceSelectDirective } from './prevent-space-select-directive';


@NgModule({
    imports: [
    ],
    exports: [
        PreventSpaceSelectDirective
    ],
    declarations: [
        PreventSpaceSelectDirective
    ]
})
export class PreventSpaceSelectDirectiveModule
{
}